import React from "react";

const Love = () => {
    return (
        <div id="quiz" className="love">
            <h2>DO WHAT YOU LOVE </h2>
            <div className="btns">
                <button className="btn">Mood tracking</button>
                <button className="btn">Guided meditations</button>
                <button className="btn">Breathing exercises</button>
                <button className="btn">Journaling</button>
                <button className="btn">Community support</button>
            </div>
            <h3>Want to blah blah?</h3>
            <p>Our mental health app is designed to provide you with a range of features and tools that can help you manage your mental health and improve your overall well-being. Overall, our mental health app offers a range of features and tools that are designed to help you manage your mental health and improve your overall well-being. Whether you're looking to reduce stress and anxiety, improve your mood, or simply maintain good mental health, our app has something to offer.</p>
            <div className='love-search'></div>
        </div>
    )
}

export default Love